<template>
  <h2 class="container my-4">
    {{$t("entries.title")}}
  </h2>

  <progress-nav :list="phaseListTerms"
                ref="progressNav"
                class="container my-4"
                breakpoint="sm"
                :isLocked="(entry.createPhase < entry.inputPhase &&insertSuccessed !== null) || (entry.createPhase >= entry.inputPhase &&updateSuccessed !== null)"
                v-on:move="shiftEntryCreatePhase"
                :borderPhase="borderPhase"
                v-if="entrySettings.confirmTerms === true" />

  <progress-nav :list="phaseListNoTerms"
                ref="progressNav"
                class="container my-4"
                breakpoint="sm"
                :isLocked="(entry.createPhase < entry.inputPhase && insertSuccessed !== null) || (entry.createPhase >= entry.inputPhase &&updateSuccessed !== null)"
                v-on:move="shiftEntryCreatePhase"
                :borderPhase="borderPhase"
                v-else-if="entrySettings.confirmTerms === false" />

  <section v-if="summaryErrors.length"
           class="container my-4">
    <validation-errors class="alert alert-danger pb-0 overflow-hidden"
                       :errors="summaryErrors" />
  </section>

  <section v-show="entry.createPhase === entry.termPhase && insertSuccessed === null">
    <section class="container my-4">
      <p class="text-pre-wrap">{{$t("entries.explain_terms")}}</p>
    </section>

    <section class="container my-4">
      <a href="/TermOfService" target="_blank">{{$t("items.terms_of_service")}}</a>
    </section>
    <section class="container my-4">
      <input type="checkbox"
             id="agreeChk"
             v-model="agreeChecked" /><label for="agreeChk">{{$t("entries.confirm_check")}}</label>
    </section>
  </section>
  <section v-show="entry.createPhase === entry.identificationPhase && insertSuccessed === null">
    <section class="container my-4">
      <p class="text-pre-wrap">{{$t("entries.explain_email")}}</p>
    </section>
    <section class="container my-4">
      <basic-input v-model="entry.email"
                   type="email"
                   :inputClass="validationClass('Email')"
                   :countVisible="true"
                   :required="true"
                   :attributes="modelAttributes.Email" />
    </section>
    <section class="container my-4">
      <basic-input v-model="entry.emailConfirm"
                   type="email"
                   :inputClass="validationClass('EmailConfirm')"
                   :countVisible="true"
                   :required="true"
                   :attributes="modelAttributes.EmailConfirm" />
    </section>
  </section>
  <section v-show="entry.createPhase === entry.identificationPhase && insertSuccessed === true">
    <section class="container my-4">
      <p class="text-pre-wrap" v-if="entrySettings.timeType === 'Minute'">{{$t("entries.notify_url_send_minute", {time: entrySettings.termOfValidity})}}</p>
      <p class="text-pre-wrap" v-else-if="entrySettings.timeType === 'Hour'">{{$t("entries.notify_url_send_hour", {time: entrySettings.termOfValidity})}}</p>
      <p class="text-pre-wrap" v-else-if="entrySettings.timeType === 'Day'">{{$t("entries.notify_url_send_day", {time: entrySettings.termOfValidity})}}</p>
    </section>
  </section>
  <section v-show="entry.createPhase === entry.inputPhase && insertSuccessed === true && updateSuccessed === null">
    <section class="container my-4">
      <p>{{$t("entries.explain_entry")}}</p>
    </section>
    <section class="container my-4">
      <basic-input v-model="entry.name"
                   type="text"
                   :inputClass="validationClass('Name')"
                   :countVisible="true"
                   :required="true"
                   :attributes="modelAttributes.Name" />
    </section>
    <section class="container my-4">
      <h4>{{$t("items.email")}}</h4>
      <p>{{entry.email}}</p>
    </section>
    <section class="container my-4" v-if="!entrySettings.autoIssuance">
      <basic-input v-model="entry.loginCode"
                   type="text"
                   :inputClass="validationClass('LoginCode')"
                   :countVisible="true"
                   :required="true"
                   :attributes="modelAttributes.LoginCode" />
      <logincode-policy-modal ref="loginCodePolicyModal" />
    </section>
    <section class="container my-4">
      <basic-input v-model="entry.password"
                   type="password"
                   :inputClass="validationClass('Password')"
                   :countVisible="true"
                   :required="true"
                   :attributes="modelAttributes.Password" />
      <password-policy-modal ref="passwordPolicyModal" />
    </section>
    <section class="container my-4">
      <basic-input v-model="entry.passwordConfirm"
                   type="password"
                   :inputClass="validationClass('PasswordConfirm')"
                   :countVisible="true"
                   :required="true"
                   :attributes="modelAttributes.PasswordConfirm" />
    </section>
  </section>
  <section v-show="entry.createPhase === entry.confirmPhase && insertSuccessed === true && updateSuccessed === null">
    <section class="container my-4">
      <p>{{$t("entries.explain_confirm")}}</p>
    </section>
    <section class="container my-4">
      <h4>{{$t("items.name")}}</h4>
      <p>{{entry.name}}</p>
    </section>
    <section class="container my-4">
      <h4>{{$t("items.email")}}</h4>
      <p>{{entry.email}}</p>
    </section>
    <section class="container my-4" v-if="!entrySettings.autoIssuance">
      <h4>{{$t("items.login_code")}}</h4>
      <p>{{entry.loginCode}}</p>
    </section>
    <section class="container my-4">
      <h4>{{$t("items.password")}}</h4>
      <p>{{$t("items.password_hidden")}}</p>
    </section>
  </section>
  <section v-show="entry.createPhase === entry.confirmPhase && updateSuccessed === true">
    <section class="container my-4" v-if="entrySettings.autoApproval">
      <p class="text-pre-wrap">{{$t("entries.notify_acceptance_with_approval")}}</p>
    </section>
    <section class="container my-4" v-else>
      <p class="text-pre-wrap">{{$t("entries.notify_acceptance")}}</p>
    </section>
  </section>
  <section class="container my-4 d-flex">
    <button type="button"
            class="btn btn-outline-success me-auto"
            v-on:click.prevent="onPrevClick">
      {{returnButtonString}}
    </button>
    <button type="button"
            class="btn btn-outline-primary ms-2"
            v-on:click.prevent="onNextClick"
            v-bind:disabled="nextButtonDisabled"
            v-if="(entry.createPhase < entry.inputPhase && insertSuccessed === null) || (entry.createPhase >= entry.inputPhase && insertSuccessed === true && updateSuccessed === null)">
      {{nextButtonString}}
    </button>
  </section>
</template>

<script>
  import { defineComponent } from "vue";
  import { xhrRequest, xhrErrors, xhrSummaryErrors } from "utils/xhr";
  import Spinner from "utils/spinner";

  import ValidationErrors from "components/base/validation_errors";

  import ProgressNav from "components/nav/progress_nav";

  import { getParameter } from "utils/url";

  import LoginCodePolicyModal from "components/modal/logincode_policy_modal";
  import PasswordPolicyModal from "components/modal/password_policy_modal";
  import BasicInput from "components/input/basic_input";

  const computed = {
    phaseListTerms() {
      return [
        this.$t("entries.create_phase_terms"),
        this.$t("entries.create_phase_identification"),
        this.$t("entries.create_phase_input"),
        this.$t("items.confirm"),
      ]
    },
    phaseListNoTerms() {
      return [
        this.$t("entries.create_phase_identification"),
        this.$t("entries.create_phase_input"),
        this.$t("items.confirm"),
      ]
    },
    nextButtonDisabled() {
      if (this.entry.createPhase === this.entry.termPhase && this.agreeChecked == false) {
        return true;
      }
      return false;
    },
    nextButtonString() {
      if (this.entry.createPhase === this.entry.termPhase) {
        return this.$t("entries.agree");
      }
      if (this.entry.createPhase === this.entry.identificationPhase) {
        return this.$t("buttons.sending");
      }
      if (this.entry.createPhase === this.entry.confirmPhase) {
        return this.$t("entries.entry");
      }

      return this.$t("buttons.next");
    },
    returnButtonString() {
      if (this.insertSuccessed === false || this.updateSuccessed === false) {
        return this.$t("buttons.return");
      }
      if (this.entry.createPhase === this.entry.termPhase) {
        return this.$t("entries.disagree");
      }
      return this.$t("buttons.return");
    },
  };

  const methods = {
    loadCreate(callback) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let spinner = new Spinner();
      xhrRequest(
        "GET",
        `entries`,
        { EntryId: this.entry.entryId },
        {
          success: data => {
            if (data.entryStatus !== "identification" || data.isUrlExpired) {
              this.entry.isUrlExpired = data.isUrlExpired;
              window.location.href = "/UrlExpired";
            } else if (this.entry.createPhase <= this.entry.identificationPhase) {
              this.id = data.id;
              this.entry.email = data.email;
              this.insertSuccessed = true;
              this.borderPhase = this.entry.identificationPhase;
            }
            this.errors = {};
            this.summaryErrors = {};
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
            this.insertSuccessed = false;
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
            if (!this.entry.isUrlExpired && this.insertSuccessed === true) {
              callback();
            }
          }
        }
      );
    },
    onNextClick() {
      if (this.entry.createPhase === this.entry.confirmPhase) {
        this.loadCreate(this.editEntry);
        return;
      }
      if (this.entry.createPhase === this.entry.identificationPhase) {
        this.validateEntry(this.addEntry);
        return;
      }
      if (this.entry.createPhase === this.entry.inputPhase) {
        this.loadCreate(this.validateEntry.bind(this, this.moveNextPhase));
        return;
      }
      this.moveNextPhase();
    },
    moveNextPhase() {
      this.$refs.progressNav.moveNextPhase();
    },
    onPrevClick() {
      if (this.entry.createPhase === 0
        || (this.entry.createPhase === this.entry.identificationPhase && this.insertSuccessed !== null)
        || (this.entry.createPhase === this.entry.inputPhase && this.updateSuccessed === null)
        || (this.entry.createPhase === this.entry.confirmPhase && this.updateSuccessed !== null)
        || this.insertSuccessed === false) {
        window.location.href = "/Login";
        return;
      }
      this.$refs.progressNav.movePrevPhase();
    },
    movePhase(phase) {
      this.$refs.progressNav.movePhase(phase);
    },
    shiftEntryCreatePhase(data) {
      this.entry.createPhase = data.phase;
    },
    validateEntry(callback) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const spinner = new Spinner();
      xhrRequest(
        "POST",
        "entries/validate",
        this.entry,
        {
          success: data => {
            this.errors = {};
            this.summaryErrors = {};
            callback();
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
          }
        }
      );
    },
    addEntry() {
      if (this.id) {
        return;
      }
      this.loading = true;
      const spinner = new Spinner();
      //TODO：言語情報のセット
      xhrRequest(
        "POST",
        "entries",
        this.entry,
        {
          success: data => {
            this.insertSuccessed = true;
          },
          error: () => {
            this.insertSuccessed = false;
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
          }
        }
      );
    },
    editEntry() {
      this.loading = true;
      const spinner = new Spinner();
      xhrRequest(
        "PUT",
        `entries/${this.id}`,
        this.entry,
        {
          success: data => {
            this.updateSuccessed = true;
            this.borderPhase = this.entry.inputPhase;
          },
          error: () => {
            this.updateSuccessed = false;
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
          }
        }
      );
    },
    validationClass(key) {
      return this.errors[key] ? "is-invalid" : null;
    },
    onLoginCodePolicyClick() {
      this.$refs.loginCodePolicyModal.openLoginCodePolicyModal();
    },
    onPasswordPolicyClick() {
      this.$refs.passwordPolicyModal.openPasswordPolicyModal();
    },
  };

  const onInit =  () => {
  };

  const onMounted = function () {
    xhrRequest(
      "GET",
      "entries/setting",
      null,
      {
        success: data => {
          this.entrySettings = data;
          if (!this.entrySettings.confirmTerms) {
            this.entry.termPhase = this.entry.termPhase - 1;
            this.entry.identificationPhase = this.entry.identificationPhase - 1;
            this.entry.inputPhase = this.entry.inputPhase - 1;
            this.entry.confirmPhase = this.entry.confirmPhase - 1;
          }
          this.entry.entryId = getParameter("entryId");
          if (this.entry.entryId !== null) {
            this.loadCreate(this.movePhase.bind(this, this.entry.inputPhase));
          }
        },
        error: () => {
        },
        complete: () => {
        }
      }
    );
    
    xhrRequest(
      "GET",
      "viewmodels/Anonymous/EntryViewModel",
      null,
      {
        success: data => {
          this.modelAttributes = data;
        },
        error: () => {
        },
        complete: () => {
        }
      }
    );
  };

  export default defineComponent({
    template: "#container",
    data: () => {
      return {
        loading: false,
        id: null,
        entry: {
          entryId: null,
          email: "",
          emailConfirm: "",
          name: "",
          loginCode: "",
          password: "",
          passwordConfirm: "",
          entryStatus: "",
          languageCode: "ja",
          isUrlExpired: false,
          createPhase: 0,
          termPhase: 0,
          identificationPhase: 1,
          inputPhase: 2,
          confirmPhase: 3,
        },
        modelAttributes: {},
        entrySettings: {},
        insertSuccessed: null,
        updateSuccessed: null,
        errors: {},
        summaryErrors: {},
        agreeChecked: false,
        nextButtonEnabled: true,
        borderPhase: null,
      }
    },
    created: onInit,
    mounted: onMounted,
    methods: methods,
    computed: computed,
    components: {
      "progress-nav": ProgressNav,
      "validation-errors": ValidationErrors,
      "password-policy-modal": PasswordPolicyModal,
      "logincode-policy-modal": LoginCodePolicyModal,
      "basic-input": BasicInput,
    },
  });
</script>
